import { render } from "./QuizType2.vue?vue&type=template&id=744fd98f&scoped=true"
import script from "./QuizType2.vue?vue&type=script&lang=js"
export * from "./QuizType2.vue?vue&type=script&lang=js"

import "./QuizType2.vue?vue&type=style&index=0&id=744fd98f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-744fd98f"]])

export default __exports__